// @ts-strict-ignore
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { toPromise } from '@fc-shared/utils/request-utils/toPromise';
import { BackendResponse } from '@fc-core/models/response.model';
import {
  VehicleNote,
  VehicleNoteForm,
} from '@fc-vehicles/vehicle-notes/models/vehicle-note.model';
import moment from 'moment-timezone';
import { NoteParams } from '@fc-projects/project-notes/models/note-params';

@Injectable({ providedIn: 'root' })
export class VehicleNoteApiService {
  http = inject(HttpClient);

  loadVehicleNotes(
    vehicleId: number,
    offset?: string,
    params?: NoteParams,
  ): Promise<[Error, BackendResponse<VehicleNote[]>]> {
    let url = `${environment.apiUrl}api/vehicle-note/?limit=10&vehicle=${vehicleId}`;
    if (offset) url = offset;
    if (params?.hasAttachments)
      url += `&has_attachments=${params.hasAttachments}`;
    if (params?.saved) url += `&pinned=${params.saved}`;
    if (params?.dateRange?.length === 2) {
      url += `&created_lower=${moment(params.dateRange[0]).toISOString()}`;
      url += `&created_upper=${moment(params.dateRange[1]).toISOString()}`;
    }
    if (params?.search) url += `&search=${params.search}`;
    if (params?.tags) url += `&tags=${params.tags}`;
    if (params?.limit) url += `&limit=${params.limit}`;
    return toPromise(this.http.get<BackendResponse<VehicleNote[]>>(url));
  }

  getVehicleNote(noteId: number): Promise<[Error, VehicleNote]> {
    return toPromise(
      this.http.get<VehicleNote>(
        `${environment.apiUrl}api/vehicle-note/${noteId}/`,
      ),
    );
  }

  createVehicleNote(
    vehicleNote: VehicleNoteForm,
  ): Promise<[Error, VehicleNote]> {
    return toPromise(
      this.http.post<VehicleNote>(
        `${environment.apiUrl}api/vehicle-note/`,
        vehicleNote,
      ),
    );
  }

  updateVehicleNote(
    vehicleNote: VehicleNoteForm,
  ): Promise<[Error, VehicleNote]> {
    return toPromise(
      this.http.patch<VehicleNote>(
        `${environment.apiUrl}api/vehicle-note/${vehicleNote.id}/`,
        vehicleNote,
      ),
    );
  }

  deleteVehicleNote(id: number): Promise<[Error, void]> {
    return toPromise(
      this.http.delete<void>(`${environment.apiUrl}api/vehicle-note/${id}/`),
    );
  }
}
